import { render, staticRenderFns } from "./addSetAccount.vue?vue&type=template&id=06c4588b&scoped=true&"
import script from "./addSetAccount.vue?vue&type=script&lang=js&"
export * from "./addSetAccount.vue?vue&type=script&lang=js&"
import style0 from "./addSetAccount.vue?vue&type=style&index=0&id=06c4588b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c4588b",
  null
  
)

export default component.exports